import { useMemo } from 'react'
import { useLocation } from 'react-router-dom'

import useLinks from '../../use-links'
import {
  MENU_DASHBOARD,
  MENU_SUPERVISION,
  MENU_STATISTICS,
  MENU_DOCUMENTS,
  MENU_WIFI,
  MENU_VOIP,
  MENU_TV_CHROMECAST,
  MENU_ADMIN,
  MENU_PROFILE,
  MENU_SILENT_MODE,
  MENU_PROJECTS
} from '../../Sidebar/constants'

const CATEGORIES = [
  MENU_DASHBOARD,
  MENU_SUPERVISION,
  MENU_STATISTICS,
  MENU_DOCUMENTS,
  MENU_WIFI,
  MENU_VOIP,
  MENU_TV_CHROMECAST,
  MENU_ADMIN,
  MENU_PROFILE,
  MENU_SILENT_MODE,
  MENU_PROJECTS
]

const Content = () => {
  const location = useLocation()

  const category = useMemo(() => {
    return CATEGORIES.find(category => {
      if (category.url && location.pathname.indexOf(category.url) === 0) {
        return true
      } else if (category.menu && category.menu.find(({ url }) => location.pathname.indexOf(url) === 0)) {
        return true
      }
      return false
    })
  }, [location])
  const links = useLinks({ menu: category?.menu || [] })

  return {
    category,
    links
  }
}

export default Content
